import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "gfu-slider",
  "data-qa": "slider-container"
}
const _hoisted_2 = { class: "_flex _jc-sb _ai-c" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-slider__controls _as-fs"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "header")
      ]),
      ($props.displayArrows)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_button, {
              theme: "white",
              shape: "circle",
              shadow: "tight",
              disabled: $props.displayArrows && !$data.isOverflownLeft,
              class: "_ba-0 _mr-1",
              "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
              onClick: $options.onScrollLeft,
              "data-qa": "left-arrow-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-left",
                  class: "_tc--accent",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "aria-label", "onClick"]),
            _createVNode(_component_base_button, {
              theme: "white",
              shape: "circle",
              shadow: "tight",
              class: "_ba-0",
              "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
              disabled: $props.displayArrows && !$data.isOverflownRight,
              onClick: $options.onScrollRight,
              "data-qa": "right-arrow-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "chevron-right",
                  class: "_tc--accent",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "disabled", "onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-slider__slides-wrapper', $props.slidesWrapperClass])
    }, [
      _createElementVNode("div", {
        ref: "slides",
        class: _normalizeClass([
                     'gfu-slider__slides',
                     {'gfu-slider__slides--negative-margin': $props.hasNegativeMargin},
                     {
                         'gfu-slider__slides--center': $props.centered && !$options.isOverflown,
                         'gfu-slider__slides--no-scroll': $props.preventScroll
                     },
                     $props.slidesClass
                 ])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ]))
}